import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "performanceFilled"
const PerformanceFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.5 8.25C20.328 8.25 21 8.922 21 9.75V20.25H21.75V21.75H2.25V20.25H3V15.75C3 14.922 3.672 14.25 4.5 14.25H6.75C7.578 14.25 8.25 14.922 8.25 15.75V20.25H9.375V12.75C9.375 11.922 10.047 11.25 10.875 11.25H13.125C13.953 11.25 14.625 11.922 14.625 12.75V20.25H15.75V9.75C15.75 8.922 16.422 8.25 17.25 8.25zM17.045 6.344 15.882 4.619 5.684 11.861 4.815 10.64 15.043 3.375 13.801 1.533 19.03 1.505z" />
        </svg>
      }
    </span>
  )
}
export default PerformanceFilledIcon
